<template>
  <div class="container">
    <img src="../../img/slider_accueil/fleche.svg" class="left fleche" alt="" @click="prev">
    <div class="slider">
      <transition name="fade">
        <p v-for="(citation, index) in citations" v-if="citation.active" :key="index">"{{ citation.texte }}"</p>
      </transition>
    </div>
    <div class="fond-points"></div>
<!--
    <img src="../../img/societe/element_petit_point_citation.svg" class="fond-image" alt="">
-->
    <img src="../../img/slider_accueil/fleche.svg" class="right fleche" alt="" @click="next">
    <div class="point-container flex-row">
      <div class="rond" v-for="(citation, index) in citations" @click="goTo(index)" :class="[{'active': citation.active}]"></div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
        return {
            citations: [
                {
                    texte: "Innovation, confiance, intégrité sont les 3 qualificatifs qui caractérisent le mieux les consultants CYBERDINE.",
                    active: true
                },
                {
                    texte: "Depuis le début de notre activité, nous avons à cœur chez CYBERDINE CONSEIL de produire un travail de qualité.",
                    active: false
                },
                {
                    texte: "Nos consultants hautement qualifiés interviennent à vos côtés en régie ou à distance pour vous procurer le support dont vous avez besoin, en mettant à votre disposition l’ensemble des compétences dont ils disposent.",
                    active: false
                },
                {
                    texte: "Être l’impulsion qui lance le moteur est notre seule façon d’atteindre les résultats attendus.",
                    active: false
                }
            ]
        }
    },
      methods: {
          goTo(index) {
              this.removeAll();
              this.citations[index].active = true;
          },
          getActivePosition() {
              return this.citations.findIndex(this.activeFilter);
          },
          activeFilter(slide) {
              return slide.active;
          },
          getLength() {
              return this.citations.length;
          },
          removeAll() {
              this.citations[this.getActivePosition()].active = false;
          },
          next() {
              let nextIndex = (this.getActivePosition()+1 == this.getLength()) ? 0 : this.getActivePosition()+1 ;
              this.removeAll();
              this.citations[nextIndex].active = true;
          },
          prev() {
              let prevIndex = (this.getActivePosition()+1 == this.getLength()) ? 0 : this.getActivePosition()+1 ;
              this.removeAll();
              this.citations[prevIndex].active = true;
          }
      }
  }
</script>

<style scoped>
  .container {
    background-color: #584d70;
    height: 750px;
    width: 100%;
    overflow-y: hidden;

    position: relative;
  }
  .container > * {
    position: absolute;
  }
  .container > .fleche {
    height: 35px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 50;
    cursor: pointer;
  }
  .container .left {
    left: 100px;
  }
  .container .right {
    right: 100px;
    transform: rotate(180deg) translateY(50%);
  }
  .fond-image {
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }
  .fond-points {
    height: 100%;
    width: 100%;
    background: url("../../img/societe/element_petit_point_citation.svg") no-repeat center center;
    background-size: cover;
    opacity: 0.4;
  }

  .slider {
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 10;
  }
  p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);

    font-size: 2.5vw;
    font-weight: 700;
    color: white;
    width: calc(100% - 500px);
    text-align: left;
    margin: 0;
  }

  .point-container {
    display: none;
    z-index: 100;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  /* Mobile */
  @media (max-width: 1000px) {
    .container {
      height: 500px;
    }
    p {
      width: calc(100% - 200px);
    }
    .container .left {
      left: 40px!important;
    }
    .container .right {
      right: 40px!important;
    }
  }
  @media (max-width: 600px) {
    .container {
      height: 350px;
    }
    p {
      width: calc(100% - 100px);
      font-size: 25px;
    }
    .fleche {
      display: none;
    }
    .point-container {
      display: flex;
      height: 50px;

      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .rond {
      height: 15px;
      width: 15px;
      margin: 0 5px;
      border-radius: 50%;
      background-color: white;
      opacity: 0.5;
      cursor: pointer;
    }
    .rond.active {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/societe/SliderCitation.vue